<template>
	<van-tabbar v-if="show" v-model="active" z-index="999" class="tabbar">
		<!-- 首页 -->
		<van-tabbar-item to="/Home">
			<span>{{ $t("footer.home") }}</span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/tn-tabbar0-curnew.png' : '/img/footer/tn-tabbar0.png'"
					:alt="$t('footer.home')" v-show="show !== 0" />
				<img :src="props.active ? '/img/footer/tn-tabbar0-curnew.png' : '/img/footer/tn-tabbar0.png'"
					:alt="$t('footer.home')" style="height: 4rem" v-show="show === 0" />
			</template>
		</van-tabbar-item>

		<!-- 影院 -->
		<van-tabbar-item to="/Choose">
			<span>{{ $t("footer.choose") }} </span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/tn-tabbar1-curnew.png' : '/img/footer/tn-tabbar1.png'"
					:alt="$t('footer.choose')" v-show="show !== 1" />
				<img :src="props.active ? '/img/footer/tn-tabbar1-curnew.png' : '/img/footer/tn-tabbar1.png'"
					:alt="$t('footer.choose')" style="height: 4rem"
					v-show="show === 1" />
			</template>
		</van-tabbar-item>

		<!-- 活动 -->
		<van-tabbar-item to="/ActivityIndex">
			<span>{{ $t("footer.activity") }}</span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/tn-tabbar2-curnew.png' : '/img/footer/tn-tabbar2.png'"
					:alt="$t('footer.activity')" v-show="show !== 2" />
				<img :src="props.active ? '/img/footer/tn-tabbar2-curnew.png' : '/img/footer/tn-tabbar2.png'"
					:alt="$t('footer.activity')" style="height: 4rem" v-show="show === 2" />
			</template>
		</van-tabbar-item>

		<!-- 我的 -->
		<van-tabbar-item to="/Mine">
			<span>{{ $t("footer.mine") }}</span>
			<template #icon="props">
				<img :src="props.active ? '/img/footer/tn-tabbar3-curnew.png' : '/img/footer/tn-tabbar3.png'"
					:alt="$t('footer.mine')" v-show="show !== 3" />
				<img :src="props.active ? '/img/footer/tn-tabbar3-curnew.png' : '/img/footer/tn-tabbar3.png'"
					:alt="$t('footer.mine')" style="height: 4rem" v-show="show === 3" />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				active: 0
			};
		},
		methods: {},
		watch: {
			$route(to) {
				if (to.name == "home") {
					this.active = 0;
					this.show = true;
				} else if (to.name == "choose") {
					this.active = 1;
					this.show = true;
				} else if (to.name == "ActivityIndex") {
					this.active = 2;
					this.show = true;
				} else if (to.name == "mine") {
					this.active = 3;
					this.show = true;
				} else {
					this.show = false;
				}
			},
		},
		created() {
			if (this.$route.name == "home") {
				this.active = 0;
				this.show = true;
			} else if (this.$route.name == "choose") {
				this.active = 1;
				this.show = true;
			} else if (this.$route.name == "ActivityIndex") {
				this.active = 2;
				this.show = true;
			} else if (this.$route.name == "mine") {
				this.active = 3;
				this.show = true;
			} else {
				this.show = false;
			}
		},
	};
</script>

<style lang="less" scoped>
	.tabbar {
		width: 100%;
		height: 62px;
		height: calc(62px + constant(safe-area-inset-bottom));
		height: calc(62px + env(safe-area-inset-bottom));
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(135deg, #667eea, #764ba2);
		z-index: 998;
		padding-bottom: calc(constant(safe-area-inset-bottom));
		padding-bottom: calc(env(safe-area-inset-bottom));
		display: flex;
		align-items: center;
		justify-content: space-around;
		box-shadow: 0 -2px 10px rgba(0, 0, 0, .1);
		border-top-left-radius: 12px;
		border-top-right-radius: 12px
	}

	::v-deep .van-tabbar-item {
		color: #aaa;
		font-size: 12px;
		position: relative;
		flex: 1;
		text-align: center;
		padding: 8px 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100%;
		line-height: 1;
		margin: 0;
		overflow: initial;
		transition: all .3s ease;
		border-radius: 8px;
		margin: 0 4px
	}

	::v-deep .van-tabbar-item:active {
		background: hsla(0, 0%, 100%, .1);
		-webkit-transform: scale(.95);
		transform: scale(.95)
	}

	::v-deep .van-tabbar-item--active {
		color: #fff;
		background-color: transparent;
	}

	::v-deep .van-tabbar-item .van-tabbar-item__icon {
		position: relative;
		display: block;
		height: auto;
		margin: 0 auto 4px;
		text-align: center;
		font-size: 21px;
		transition: all .3s ease
	}

	::v-deep .van-tabbar-item .van-tabbar-item__icon img {
		width: 28px;
		height: 28px;
		display: inline-block;
		transition: all .3s ease
	}

	::v-deep .van-tabbar-item .van-tabbar-item__icon {
		-webkit-transform: translateY(-2px);
		transform: translateY(-2px)
	}

	::v-deep .van-tabbar-item.active .van-tabbar-item__icon img {
		-webkit-transform: scale(1.1);
		transform: scale(1.1)
	}

	::v-deep .van-tabbar-item .bar-circle {
		position: relative;
		display: block;
		margin: 0px auto 0px;
		text-align: center;
		font-size: 27px;
		line-height: 46px;
		width: 52px !important;
		height: 52px !important;
		overflow: hidden
	}

	::v-deep .van-tabbar-item .bar-circle img {
		width: 52px;
		height: 52px;
		display: inline-block;
		margin: 0px auto 0px
	}

	.tabbar .bar-center {
		-webkit-animation: suspension-data-v-158872fa 3s ease-in-out infinite;
		animation: suspension-data-v-158872fa 3s ease-in-out infinite
	}

	.tabbar .bar-center .nav-index-button {
		-webkit-animation: suspension-data-v-158872fa 3s ease-in-out infinite;
		animation: suspension-data-v-158872fa 3s ease-in-out infinite;
		z-index: 999999
	}

	.tabbar .bar-center .nav-index-button__content {
		position: absolute;
		width: 52px;
		height: 52px;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%)
	}

	.tabbar .bar-center .nav-index-button__content--icon {
		width: 52px;
		height: 52px;
		font-size: 31px;
		border-radius: 50%;
		margin-bottom: 9px;
		position: relative;
		z-index: 1;
		-webkit-transform: scale(.85);
		transform: scale(.85)
	}

	.tabbar .bar-center .nav-index-button__content--icon::after {
		content: " ";
		position: absolute;
		z-index: -1;
		width: 100%;
		height: 100%;
		left: 0;
		bottom: 0;
		border-radius: inherit;
		opacity: 1;
		-webkit-transform: scale(1);
		transform: scale(1);
		background-size: 100% 100%
	}

	.tabbar .bar-center .nav-index-button__meteor {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 52px;
		height: 52px;
		-webkit-transform-style: preserve-3d;
		transform-style: preserve-3d;
		-webkit-transform: translate(-50%, -50%) rotateY(75deg) rotate(10deg);
		transform: translate(-50%, -50%) rotateY(75deg) rotate(10deg)
	}

	.tabbar .bar-center .nav-index-button__meteor__wrapper {
		width: 52px;
		height: 52px;
		-webkit-transform-style: preserve-3d;
		transform-style: preserve-3d;
		-webkit-animation: spin-data-v-158872fa 20s linear infinite;
		animation: spin-data-v-158872fa 20s linear infinite
	}

	.tabbar .bar-center .nav-index-button__meteor__item {
		position: absolute;
		width: 52px;
		height: 52px;
		border-radius: 520px;
		left: 0;
		top: 0
	}

	.tabbar .bar-center .nav-index-button__meteor__item--pic {
		display: block;
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
		-webkit-animation: arc-data-v-158872fa 4s linear infinite;
		animation: arc-data-v-158872fa 4s linear infinite
	}

	@-webkit-keyframes suspension-data-v-158872fa {

		0%,
		100% {
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}

		50% {
			-webkit-transform: translateY(-.6rem);
			transform: translateY(-.6rem)
		}
	}

	@keyframes suspension-data-v-158872fa {

		0%,
		100% {
			-webkit-transform: translateY(0);
			transform: translateY(0)
		}

		50% {
			-webkit-transform: translateY(-.6rem);
			transform: translateY(-.6rem)
		}
	}

	@-webkit-keyframes spin-data-v-158872fa {
		0% {
			-webkit-transform: rotateX(0deg);
			transform: rotateX(0deg)
		}

		100% {
			-webkit-transform: rotateX(-1turn);
			transform: rotateX(-1turn)
		}
	}

	@keyframes spin-data-v-158872fa {
		0% {
			-webkit-transform: rotateX(0deg);
			transform: rotateX(0deg)
		}

		100% {
			-webkit-transform: rotateX(-1turn);
			transform: rotateX(-1turn)
		}
	}

	@-webkit-keyframes arc-data-v-158872fa {
		to {
			-webkit-transform: rotate(1turn);
			transform: rotate(1turn)
		}
	}

	@keyframes arc-data-v-158872fa {
		to {
			-webkit-transform: rotate(1turn);
			transform: rotate(1turn)
		}
	}
</style>
